import { OptionalAmount } from "./OptionalAmount";

export enum TransactionStatus {
  Completed = "Completed",
  Voided = "Voided"
}

export interface VoidedInfo {
  voidedAt: string;
  voidedByUserEmail: string;
  reason?: string;
}

export default interface OrderTransaction {
  id: string;
  number: string;
  orderNumber: string;
  clientTicketRef: string;
  loadedAt: string;
  siteName: string;
  orderRef: string;
  ticketNotes: string;
  acres: number;
  totalDispensed: OptionalAmount;
  totalOrderRequested: OptionalAmount;
  status: TransactionStatus;
  customer: OrderTransactionCustomer;
  destination?: OrderTransactionDestination;
  driver?: OrderTransactionDriver;
  branch?: OrderTransactionBranch;
  transports: OrderTransactionTransport[];
  compartments: OrderTransactionCompartment[];
  carrier?: OrderTransactionCarrier;
  applicator?: OrderTransactionApplicator;
  blends: OrderTransactionBlend[];
  voidedInfo?: VoidedInfo;
  partnerBusinessName?: string;
  partnerSiteName?: string;
}

interface OrderTransactionCustomer {
  name: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  customerRef: string;
}

interface OrderTransactionDestination {
  name: string;
  street: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  destinationRef: string;
}

interface OrderTransactionDriver {
  name: string;
  number: string;
  driverRef: string;
}

interface OrderTransactionBranch {
  name: string;
  number: string;
  branchRef: string;
}

interface OrderTransactionTransport {
  name?: string;
  number?: string;
  transportRef?: string;
}

interface OrderTransactionCompartment {
  transportCompartmentIndex?: number;
  transportRef?: string;
}

interface OrderTransactionCarrier {
  name: string;
  number?: string;
  carrierRef: string;
}

interface OrderTransactionApplicator {
  name: string;
  license?: string;
  epaNumber?: string;
  applicatorRef?: string;
}

interface OrderTransactionBlend {
  id: string;
  blendRef?: string;
  items: OrderTransactionItem[];
}

interface OrderTransactionItem {
  itemName: string;
  blendItemRef?: string;
  productRef?: string;
  recipeRef?: string;
  amount: string;
  unit: string;
  measurements: OrderTransactionMeasurement[];
}

interface OrderTransactionMeasurement {
  amount: string;
  unit: string;
  ingredientName: string;
  legalForTrade: boolean;
  compartmentIndex?: number;
  density?: OrderTransactionDensity;
}

interface OrderTransactionDensity {
  value: number;
  massUnit: string;
  volumeUnit: string;
}